/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-01-21T19:19:46-08:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-08-11T14:14:46-07:00
*/



import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { dimensions, spacing, type, textColor } from '../../style';

const style = StyleSheet.create({
  inputGroup: {
    display: 'flex',
    flexDirection: 'column',
    ...spacing.MARGIN_BOTTOM_MD,

    [dimensions.SCREEN_MIN_MD]: {
      flexDirection: 'row',
      ...spacing.MARGIN_BOTTOM_MD,
    },

    [':last-child:not(:first-child)']: {
      marginBottom: 0
    }
  },

  vertical: {
    display: 'block'
  },

  inputLabel: {
    flexBasis: '22px',
    ...spacing.MARGIN_RIGHT_MD,
    ...spacing.MARGIN_TOP_SM,
    ...spacing.MARGIN_BOTTOM_SM,
    ...type.BOLD,
    whiteSpace: 'pre-line',

    [dimensions.SCREEN_MIN_MD]: {
      flexBasis: '120px',
      textAlign: 'right',
    }
  },

  inputSpacer: {
    [dimensions.SCREEN_MIN_MD]: {
      flexBasis: '120px',
      ...spacing.MARGIN_RIGHT_MD,
      textAlign: 'right',
    }
  },

  inputLabel_stacked: {
    display: 'inline-block',
    marginTop: '0',

    [dimensions.SCREEN_MIN_MD]: {
      textAlign: 'initial',
    }
  },

  inputControl: {
    [dimensions.SCREEN_MIN_MD]: {
      flex: '0 0 400px'
    }
  },

  errorDescription: {
    ...spacing.MARGIN_TOP_XS,
    ...textColor.RED
  }
})



const InputGroup = (props) => {

  const classNames = css(
    style.inputGroup,
    props.vertical && style.vertical,
  );

  let errorText = null;
  if(props.errors) {
    errorText = (
      <div className={css(style.errorDescription)}>
        {props.errors}
      </div>
    )
  }

  return (
    <div className={classNames}>
      {!props.vertical && !props.inputLabel && <div className={css(style.inputSpacer)} />}
      {props.inputLabel && <label className={css(style.inputLabel, props.vertical && style.inputLabel_stacked)}>{props.inputLabel}</label>}
      <div className={css(style.inputControl)}>
        {props.children}
        {errorText}
      </div>
    </div>
  )
}



export default InputGroup;



// WEBPACK FOOTER //
// ./src/components/blocks/InputGroup.jsx